import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardContent } from '@/layouts/dashboard';
import { cn } from '@/lib/utils';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { TiaBanner } from '@/components/custom/tia-banner';
import { Sheet, SheetBody, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { DialogTitle } from '@/components/ui/dialog';
import tiaInstrucoes from '@/assets/images/tia/TIA-INSTRUCOES.png';
import { ExercisesArchivePlayful } from './ExercisesArchivePlayful';
import { ExercisesMetricsPlayful } from './ExercisesMetricsPlayful';
import { ExercisesCreateWizard } from '../ExercisesCreateWizard';

const PLAYFUL_TAB_CLASSNAME =
  'flex-1 md:flex-none data-[state=active]:bg-[var(--color-mission)] data-[state=active]:text-white data-[state=active]:font-extrabold data-[state=active]:shadow-[0_3px_0_var(--color-mission-dark)] data-[state=active]:-translate-y-px';

const TIA_MESSAGE_BY_TAB = {
  apostilas: 'Escolha um caderno e comece a praticar. Bora dominar o assunto? 📝',
  'resultados-das-apostilas': 'Seu resultado nos exercícios. Continue praticando pra evoluir! 📊'
};

function ExercisesPlayful({ uri, selectedTab }) {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(selectedTab || 'apostilas');
  const [showModal, setShowModal] = useState(false);
  const [onlyMine, setOnlyMine] = useState(false);

  const BASE_ROUTE = '/questions';

  const handleTabChange = tab => {
    setActiveTab(tab);
    navigate(`${BASE_ROUTE}/${tab}`);
  };

  const breadcrumbs = {
    title: 'Exercícios',
    nav: [
      {
        route: uri,
        name: 'Exercícios',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadcrumbs}
    >
      <Tabs
        value={activeTab}
        onValueChange={handleTabChange}
      >
        <TiaBanner
          className="mb-6 md:mt-16"
          image={tiaInstrucoes}
          text={TIA_MESSAGE_BY_TAB[activeTab]}
        />

        <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-center">
          <TabsList className="w-full border border-neutral-lighter bg-white md:w-auto">
            <TabsTrigger
              value="apostilas"
              className={PLAYFUL_TAB_CLASSNAME}
            >
              Exercícios
            </TabsTrigger>
            <TabsTrigger
              value="resultados-das-apostilas"
              className={PLAYFUL_TAB_CLASSNAME}
            >
              Resultados
            </TabsTrigger>
          </TabsList>

          {activeTab === 'apostilas' && (
            <>
              <button
                type="button"
                onClick={() => setOnlyMine(prev => !prev)}
                className={cn(
                  'w-full rounded-full border px-4 py-2 text-sm font-semibold transition-colors md:w-auto',
                  onlyMine ? 'border-[var(--color-mission)] bg-[var(--color-mission)] text-white' : 'border-neutral-lighter bg-white text-neutral-dark'
                )}
              >
                Meus cadernos
              </button>

              <Sheet
                open={showModal}
                onOpenChange={setShowModal}
              >
                <SheetTrigger asChild>
                  <button
                    type="button"
                    className="group/btn relative w-full overflow-hidden rounded-full px-6 py-3 text-sm font-extrabold text-white transition-transform duration-100 active:scale-[0.97] md:ml-auto md:w-auto"
                    style={{ background: 'var(--gradient-btn-continue)', boxShadow: '0 4px 0 var(--color-mission-dark), 0 6px 12px rgba(245,123,46,0.35)' }}
                  >
                    <span
                      aria-hidden="true"
                      className="pointer-events-none absolute inset-x-0 top-0 h-1/2 rounded-t-full"
                      style={{ background: 'linear-gradient(180deg, rgba(255,255,255,0.22) 0%, transparent 100%)' }}
                    />
                    <span className="relative">Criar exercício</span>
                  </button>
                </SheetTrigger>

                <SheetContent>
                  <DialogTitle className="sr-only">Novo exercício</DialogTitle>
                  <SheetBody className="py-6">
                    <ExercisesCreateWizard setShowModal={setShowModal} />
                  </SheetBody>
                </SheetContent>
              </Sheet>
            </>
          )}
        </div>

        <TabsContent value="apostilas">
          <ExercisesArchivePlayful onlyMine={onlyMine} />
        </TabsContent>
        <TabsContent value="resultados-das-apostilas">
          <ExercisesMetricsPlayful />
        </TabsContent>
      </Tabs>
    </DashboardContent>
  );
}

export default ExercisesPlayful;
